import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=2040ad8a&scoped=true&"
var script = {}
import style0 from "./Print.vue?vue&type=style&index=0&id=2040ad8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040ad8a",
  null
  
)

export default component.exports